export const FIXED_PRICE_PLACEHOLDER = '2000';
export const MIN_HOURLY_BUDGET_RANGE_PLACEHOLDER = '75';
export const MAX_HOURLY_BUDGET_RANGE_PLACEHOLDER = '125';
export const MAX_RECOMMENDED_DELIVERY_FREQUENCY = 100;
export const SECOND_IN_MS = 1000;
